import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdfiService } from '@services/adfi-service';
import { SelectItemComponent } from '@Components/ui/select-item/select-item.component';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { CurrencyPipe } from '@Components/util/currency.pipe';
import { Filter } from '@Components/ui/util/Filter';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogData } from '@Components/ui/confirm-dialog/confirm-dialog.component';
import { ENUM_ACTIONS, PeriodState } from '@Interfaces/index';
import { LoadingService } from '@services/loading.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { NavRouteService } from '@services/nav-routing-service';

@Component({
  selector: 'app-assign-responsible',
  templateUrl: './assign-responsible.component.html',
})

export class AssignResponsibleComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  assetsRelated: any[];
  todayDate = new Date();
  minimunDate = new Date(this.todayDate);
  type: string;
  listValues = new Map<string, any[]>();
  listCustomValues = new Map<string, any[]>();
  loadingListValues = new Map<string, boolean>();
  movementAssetsForm: FormGroup;
  inventoryType:number;
  block: boolean;

  constructor(
    private service: AdfiService,
    private dialog: MatDialog,
    private adfiGrowl: AdfiGrowlService,
    private adfiGraphql: AdfiGraphqlService,
    private loadingService: LoadingService,
    public gaService: GoogleAnalyticsService,
    private navRouteService: NavRouteService
  ) { }

  ngOnInit() {
    this.block = this.service.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS);  
    this.loadDates();
    this.getSede();
    this.getLocation();
    this.movementAssetsForm = new FormGroup({
      responsible: new FormControl('', Validators.required),
      deliveryDate: new FormControl('', Validators.required),
      observation: new FormControl('', Validators.maxLength(1000)),
      state: new FormControl('', Validators.required),
      sede: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
      assets: new FormControl('', Validators.required)
    });
  }

  selectResponsible() {
    let dialogRef: MatDialogRef<any>;
    const data = {
      module: "MovimientoBienes",
      entityName: "PpeEmployee",
      enableAdd: false,
      defaultFilters: [
        {
          column: "cencos",
          value: "",
        },
        {
          column: "charge",
          value: true
        }
      ],
      customTitle: 'Seleccionar Responsable'
    };

    dialogRef = this.dialog.open(SelectItemComponent, {
      data,
      width: "80%",
      maxHeight: "70vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        result.toString = () => {
          return `${result.document} - ${result.name}`;
        };
      }

      this.movementAssetsForm.get('responsible').setValue(result);
    });
  }

  selectAssets() {
    let dialogRef: MatDialogRef<any>;
    const data = {
      module: "MovimientoBienes",
      entityName: "ActivoFijo",
      enableAdd: false,
      defaultFilters: [
        {
          column: "cencos",
          value: ""
        },
        {
          column: "enServicio",
          value: [0]
        },
        {
          column: "dateDown",
          value: false,
          filter: 'existsFilter'
        },
        {
          column: "isActive",
          value: true
        },
        {
          column: "inventoryType",
          value: [this.inventoryType]
        },
        {
          column: "assetsState",
          value: 'CS'
        }
      ],
      customTitle: 'Seleccionar Bienes a Asignar',
      multiSelect: this.movementAssetsForm.get('assets').value,
      displayGroup: 'GA'
    };

    dialogRef = this.dialog.open(SelectItemComponent, {
      data,
      width: "80%",
      maxHeight: "70vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.length) {
        result = result.filter((value, index, self) => index === self.findIndex((obj) => obj.id === value.id));
        if (Array.isArray(result)) {
          result.forEach(value => {
            value.toString = () => {
              return `${value.consecutive} - ${value.descripcion} - ${value.nroSerial}`;

            }
          });
          this.movementAssetsForm.get('assets').setValue(result);
        }
      }
    });
  }

  removeItem(path: string) {
    this.movementAssetsForm.get(path).reset();
  }

  removeItems(path: string, item: any) {
    this.movementAssetsForm.get(path).setValue(this.movementAssetsForm.get(path).value.filter(value => (value !== item)));
  }


  getSede() {
    const next = (list: any[]) => {
      this.listValues.set('Sede', list);
      this.loadingListValues.set('Sede', false);
    };
    const error = (e) => {
      this.loadingListValues.set('Sede', false);
      this.adfiGrowl.errorMessage(e);
    };
    this.listValues.set('Sede', []);
    this.loadingListValues.set('Sede', true);

    const f = new Filter(this.service);
    f.entityName = 'Sede';
    f.module = '';
    f.defaultQuery = [{ column: "cencos", value: "" }];
    f.loadedConfig.subscribe(async () => {
      const params: any = f.generateFilters();
      const count = await this.adfiGraphql.countEntity(f.configTable.plural, params);
      this.adfiGraphql.getEntity(f.configTable.plural, 'nombre', count, params, { next, error });
    });
    f.loadConfig();
  }

  getLocation() {
    const next = (list: any[]) => {
      this.listValues.set('Lugar', list);
      this.loadingListValues.set('Lugar', false);
    };
    const error = (e) => {
      this.loadingListValues.set('Lugar', false);
      this.adfiGrowl.errorMessage(e);
    };
    this.listValues.set('Lugar', []);
    this.loadingListValues.set('Lugar', true);

    const f = new Filter(this.service);
    f.entityName = 'Location';
    f.module = '';
    f.loadedConfig.subscribe(async () => {
      const params: any = f.generateFilters();
      const count = await this.adfiGraphql.countEntity(f.configTable.plural, params);
      this.adfiGraphql.getEntity(f.configTable.plural, 'name', count, params, { next, error });
    });
    f.loadConfig();
  }

  getAllFilters() {
    return {
      responsible: this.movementAssetsForm.get('responsible').value,
      deliveryDate: this.movementAssetsForm.get('deliveryDate').value,
      state: this.movementAssetsForm.get('state').value,
      observation: this.movementAssetsForm.get('observation').value,
      sede: this.movementAssetsForm.get('sede').value,
      location: this.movementAssetsForm.get('location').value,
      assets: this.movementAssetsForm.get('assets').value,
    };
  }

  cancel() {
    this.inventoryType = null;
    this.movementAssetsForm.get('assets').reset();
  }

  save(form: FormGroupDirective) {
    if (!form.valid) {
      return;
    }
    const content = undefined;
    const data: ConfirmDialogData = {
      title: '¿Desea guardar la información?',
      content,
      action: ENUM_ACTIONS.CREATE
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadingService.show();
        const next = async (r) => {
          this.adfiGrowl.success('GUARDADO', 'El registro se ha agregado correctamente');
          this.gaService.event('Guardar', 'ADFI', 'Seleccionar Bienes', this.service.user.id);
          setTimeout(() => {
            this.navRouteService.navigate('list/ZXNGODl4cUsrZHNxTlFBR1Rkc05lZz09/ZE10NDZoNkY5ZFkvTGljY2FjWWJiSUk9');
          }, 1000);
        };
        const error = (e) => {
          this.adfiGrowl.errorMessage(e);
          this.loadingService.hide();
        };
        this.adfiGraphql.createEntity('Action', {
          nameClass: 'registerAsset',
          filters: JSON.stringify(this.getAllFilters()),
          actions: JSON.stringify({}),
          message: JSON.stringify({})
        }, 'message actions', { next, error });
      }
    });
  }

  loadDates() {
    const next = (v: any) => {
      this.minimunDate = v.fechaApertura;
    };
    const error = (e) => {
      this.adfiGrowl.errorMessage(e, 'Error al cargar la vigencia del usuario');
    };
    this.service.getPeriodByUser({ next, error });
  }

  onButtonClick() {
    this.close.emit();
  }

}
